import DoneIcon from '@mui/icons-material/Done';
import React, { useEffect, useState } from 'react';
import styles from './SelectPill.module.scss';

function SelectPill({ selected, id, label, onChange, disabled }) {
  const [isSelected, setIsSelected] = useState(selected);
  useEffect(() => {
    setIsSelected(selected);
  }, [selected]);
  return (
    <>
      <input
        onChange={onChange}
        type="checkbox"
        className={`${styles.input} form-check-input`}
        name="flexRadioDefault"
        id={id}
        defaultChecked={isSelected}
        disabled={disabled}
      />
      <label
        onClick={() => {
          if (!disabled) {
            setIsSelected(!isSelected);
          }
        }}
        role="presentation"
        className={`${isSelected ? styles.labelActive : styles.labelInActive} ${disabled ? '' : styles.withHover}`}
        htmlFor={id}
      >
        {label} {isSelected && <DoneIcon className={styles.tickIcon} />}
      </label>
    </>
  );
}

export default SelectPill;
